<template>
  <section class="cons">
    <button type="button" class="cons__toggle" :aria-expanded="open ? 'true' : 'false'" @click="open = !open">
      <i class="cons__chevron" :class="open ? 'ri-arrow-down-s-line' : 'ri-arrow-right-s-line'" aria-hidden="true"></i>
      <span class="cons__title">Забрать со склада</span>
      <span v-if="status === 'ready'" class="cons__count">{{ rows.length }}</span>
    </button>
    <div v-if="open" class="cons__body">
      <div v-if="status === 'loading' || status === 'idle'" class="cons__loading">
        <span class="spinner-border spinner-border-sm text-primary" role="status"><span class="sr-only">Загрузка…</span></span>
      </div>
      <div v-else-if="status === 'error'" class="alert alert-danger py-2 px-3 mb-0 d-flex align-items-center cons__error" role="alert">
        <span>Не удалось загрузить расходники: {{ errorText }}</span>
        <button type="button" class="btn btn-sm btn-light ml-auto cons__retry" @click="$emit('retry')">Повторить</button>
      </div>
      <div v-else-if="!rows.length" class="cons__empty">{{ emptyText }}</div>
      <ul v-else class="cons__list">
        <li v-for="r in rows" :key="r.id" class="cons__row">
          <span class="cons__name">{{ r.title }}</span>
          <span class="cons__qty">{{ r.quantity }}</span>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { CONSUMABLES_EMPTY } from '@/components/field/fieldTasksLogic';
import { errorMessage } from '@/components/management/dispatcher/resource';

/** «Забрать со склада» (KOP-40 spec §6.4): collapsed on every visit; dumb. */
export default {
  name: 'ConsumablesBlock',
  props: {
    rows: { type: Array, default: () => [] },
    status: { type: String, default: 'idle' },
    error: { type: [Object, Error], default: null },
  },
  data() {
    return { open: false };
  },
  computed: {
    emptyText() { return CONSUMABLES_EMPTY; },
    errorText() { return errorMessage(this.error); },
  },
};
</script>

<style scoped lang="scss">
.cons { background: #fff; border: 1px solid #e3e5e1; border-radius: 12px; }
.cons__toggle { width: 100%; min-height: 44px; display: flex; align-items: center; gap: 8px; padding: 0 14px; border: 0; background: transparent; text-align: left; font-weight: 700; font-size: 14px; color: #1d221f; }
.cons__chevron { font-size: 18px; color: #8b918c; }
.cons__count { margin-left: auto; font-size: 12px; font-weight: 600; color: #8b918c; }
.cons__body { border-top: 1px solid #e3e5e1; padding: 8px 14px 10px; }
.cons__loading { display: flex; justify-content: center; padding: 8px 0; }
.cons__empty { color: #8b918c; font-size: 13px; padding: 4px 0; }
.cons__list { list-style: none; margin: 0; padding: 0; }
.cons__row { display: flex; justify-content: space-between; gap: 12px; padding: 6px 0; font-size: 13px; border-bottom: 1px dashed #eceeea; &:last-child { border-bottom: 0; } }
.cons__qty { font-weight: 700; color: #1d221f; white-space: nowrap; }
</style>
